import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { track, pageKeyOf, handleTrackedClick } from '../utils/analytics';

const PRIVATE = /^\/(admin|contract|sign|ambassador-portal)/;

// Public page views + global click delegation (admin area excluded).
export const AnalyticsTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (PRIVATE.test(pathname)) return;
    track('page_view', { target: pageKeyOf(pathname) });
  }, [pathname]);
  useEffect(() => {
    const onClick = (e) => { if (!PRIVATE.test(window.location.pathname)) handleTrackedClick(e); };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);
  return null;
};
